import styled from 'styled-components';

import { colors, transition } from 'theme';

export type InputStatus = 'neutral' | 'success' | 'error';
export type InputStyleVariant = 'default' | 'contrast' | 'light-border';
export type InputPrefixVariant = 'default' | 'transparent';

export const InputContainer = styled.div<{
  $status: InputStatus;
  $styleVariant: InputStyleVariant;
  $prefixVariant: InputPrefixVariant;
  $fullHeight: boolean;
}>`
  position: relative;
  overflow: hidden;
  display: flex;

  font-size: 18px;
  height: ${({ $fullHeight }) => ($fullHeight ? '100%' : '45px')};
  background: var(--input-background-color);

  border-radius: 8px;
  color: ${colors.charcoalGrey};
  transition: all ${transition};

  &::placeholder {
    color: ${colors.middleGrey};
  }

  &:focus-within {
    border-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue};
  }

  ${
    // eslint-disable-next-line consistent-return
    ({ $status }) => {
      switch ($status) {
        case 'neutral':
          return `
            --input-highlight-color: var(--colors-silver);
          `;
        case 'success':
          return `
            --input-highlight-color: green;
            box-shadow: 0 0 0 1px var(--input-highlight-color);
          `;
        case 'error':
          return `
            --input-highlight-color: red;
            box-shadow: 0 0 0 1px var(--input-highlight-color);
          `;
      }
    }
  }

  ${
    // eslint-disable-next-line consistent-return
    ({ $prefixVariant }) => {
      switch ($prefixVariant) {
        case 'default':
          return `
            --input-affix-text-color: var(--color-battleshipGrey);
            --input-affix-background-color: var(--color-aluminum);
           
            &:focus-within {
              --input-affix-text-color: ${colors.white};
              --input-affix-background-color: ${colors.waterBlue};
            }
        `;
        case 'transparent':
          return `
            --input-affix-text-color: var(--color-middleGrey);
            
            &:focus-within {
              --input-affix-text-color: ${colors.waterBlue};
            }
        `;
      }
    }
  }

  ${
    // eslint-disable-next-line consistent-return
    ({ $styleVariant }) => {
      switch ($styleVariant) {
        case 'default':
          return `
            --input-background-color: var(--color-white);
            --input-highlight-color: var(--color-silver);
            border: solid 1px var(--input-highlight-color);
          `;
        case 'contrast':
          return `
            --input-background-color: var(--color-platinum);
            --input-highlight-color: var(--color-silver);
          `;
        case `light-border`:
          return `
            --input-background-color: var(--color-white);
            --input-highlight-color: var(--color-aluminum);
            border: solid 1px var(--input-highlight-color);
          `;
      }
    }
  }
`;

export const InputAffixLabel = styled.label`
  height: 100%;
  display: inline-flex;
  align-items: center;
  color: var(--input-affix-text-color);
  background: var(--input-affix-background-color);
  transition: all var(--transition);
`;

/* The input itself doesn't have many styles, most are applied to the container */
export const InputElement = styled.input`
  padding: 11px 1em;
  flex: 1;

  appearance: none;
  box-shadow: none;
  border: none;
  outline: none;
  font: inherit;
  background: transparent;
`;
